import { FC } from "react";
import { Drawer } from "shared/ui/drawer"
import { DiaryFiltersRangeItem } from "./DiaryFiltersRangeItem";
import { DiaryFiltersBody, DiaryFiltersDrawerWrapper, DiaryFiltersFooter } from "./styles";
import { NewEntrieHead, NewEntrieTitle } from "../styles";
import { CloseIcon } from "shared/ui/icons";
import { toRem } from "shared/helpers";
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import { Control } from "react-hook-form";
import { DiaryFiltersFormValues, Owner } from "shared/types";
import { dictionaryItem } from "features/diary/lib/useDiaryFilters";
import { DiaryDictionariesFilter } from "./DiaryDictionariesFilter";
// import { DiaryAttachmentsFilter } from "./DiaryAttachmentsFilter";
import { DiaryCommentFilter } from "./DiaryCommentFilter";
import { DiaryFiltersAuthors } from "./DiaryFiltersAuthors";

type DiaryFiltersDrawerProps = {
  isOpen: boolean;
  control: Control<DiaryFiltersFormValues, any, DiaryFiltersFormValues>;
  formValues: Partial<DiaryFiltersFormValues>;
  dictionaryItems: dictionaryItem[];
  isMobile?: boolean;
  showResetAll: boolean;
  usersList?: Owner[];
  onClose: () => void;
  onRangeChange: (name: keyof DiaryFiltersFormValues, value: string) => void;
  onResetItems: (names: (keyof DiaryFiltersFormValues)[]) => void;
  onDictionaryItemClick: (id: string) => void;
  onDictionaryReset: () => void;
  setHasAttachments: (value: boolean) => void;
  onCommentChange: (value: string[]) => void;
  onAllReset?: () => void;
  onSubmit: () => void;
  onAuthorClick: (id: string) => void;
}

export const DiaryFiltersDrawer: FC<DiaryFiltersDrawerProps> = ({
  isOpen,
  control,
  formValues,
  dictionaryItems,
  isMobile,
  showResetAll,
  usersList,
  onClose,
  onRangeChange,
  onResetItems,
  onDictionaryItemClick,
  onDictionaryReset,
  // setHasAttachments,
  onCommentChange,
  onAllReset,
  onSubmit,
  onAuthorClick
}) => {

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      position="right"
    >
      <DiaryFiltersDrawerWrapper>
        <NewEntrieHead>
          <Button 
            iconPrefix={<CloseIcon />}
            variant="secondary"
            colorScheme="neutral"
            style={{alignSelf: 'flex-end', width: isMobile ? toRem(24) : toRem(36)}}
            size={isMobile ? 's' : 'm'}
            onClick={onClose}
          />
          <NewEntrieTitle>
            <span>Фильтры</span>
            {(showResetAll) && <button onClick={onAllReset}>Сбросить все</button>}
          </NewEntrieTitle>
        </NewEntrieHead>
        <DiaryFiltersBody>
          {(usersList&&Boolean(usersList?.length)) && <DiaryFiltersAuthors authors={usersList} ids={formValues.authorIds || []} onAuthorClick={onAuthorClick} />}
          <DiaryFiltersRangeItem 
            name="frames"
            control={control}
            fieldNames={{from: 'framesFrom', to: 'framesTo'}}
            onChange={onRangeChange}
            onReset={onResetItems}
            showReset={Boolean(formValues.framesFrom?.trim()||formValues.framesTo?.trim())}
          />
          <DiaryFiltersRangeItem 
            name="strength"
            control={control}
            fieldNames={{from: 'strengthFrom', to: 'strengthTo'}}
            onChange={onRangeChange}
            onReset={onResetItems}
            showReset={Boolean(formValues.strengthFrom?.trim()||formValues.strengthTo?.trim())}
          />
          <DiaryFiltersRangeItem 
            name="brood"
            control={control}
            fieldNames={{from: 'broodFrom', to: 'broodTo'}}
            onChange={onRangeChange}
            onReset={onResetItems}
            showReset={Boolean(formValues.broodFrom?.trim()||formValues.broodTo?.trim())}
          />

          <DiaryDictionariesFilter 
            formValues={formValues}
            onDictionaryReset={onDictionaryReset}
            dictionaryItems={dictionaryItems}
            isDrawer
            onDictionaryItemClick={onDictionaryItemClick}
          />
          <DiaryCommentFilter 
            formValues={formValues}
            control={control}
            onCommentChange={onCommentChange}
          />
          {/* <DiaryAttachmentsFilter 
            formValues={formValues}
            setHasAttachments={setHasAttachments}
          /> */}
        </DiaryFiltersBody>
        <DiaryFiltersFooter>
          <Button 
            label="Применить"
            style={{width: '100%'}}
            onClick={() => onSubmit()}
          />
        </DiaryFiltersFooter>
      </DiaryFiltersDrawerWrapper>
    </Drawer>
  )
}